export const STATUS_FAILED = 'FAILED';
const STATUS_ACCEPTED_BY_BANK = 'ACCEPTED_BY_BANK';
const STATUS_PENDING_WITH_BANK = 'PENDING_WITH_BANK';
const STATUS_AWAITING_AUTHORIZATION = 'AWAITING_AUTHORIZATION';

const FAILED = 'Failed';
const ACCEPTED = 'Accepted';
const PENDING = 'Pending';
const AWAITING_AUTHORIZATION = 'Awaiting authorization';

interface LabelValue {
  label: string;
  value: string;
}

export const STATUS_FILTER_OPTIONS: LabelValue[] = [
  { label: FAILED, value: STATUS_FAILED },
  { label: ACCEPTED, value: STATUS_ACCEPTED_BY_BANK },
  { label: PENDING, value: STATUS_PENDING_WITH_BANK },
  { label: AWAITING_AUTHORIZATION, value: STATUS_AWAITING_AUTHORIZATION },
];

export const PAYOUTS_SINGLE = 'payouts-single';
export const PAYOUTS_BULK = 'payouts-bulk';

export const PAYOUTS_SIGN_UP_URL = '/payouts/users/sign-up';
export const PAYOUTS_CONNECT_URL = '/payouts/users/connect';

export const INITIATE_SINGLE_PAYOUT = '/payouts/v1/payment';

export const CANCEL_PAYOUT_URL = '/payouts/v1/cancel';

export const AUTHORIZE_PAYOUT_URL = '/payouts/v1/authorize';

export const PAYOUTS_AUTHORIZATION_RULE = '/payouts/authorization-rules';

export const VALIDATE_BULK_PAYOUT = '/payouts/validate';

export const INITIATE_PAYOUT_ASYNC = '/payouts/initiate-async';

export const AMOUNT_THRESHOLD = 'AMOUNT_THRESHOLD';

export const MANUAL_APPROVAL = 'MANUAL_APPROVAL';

export const SINGLE_PAYOUT_TYPE = 'SINGLE';

export const BULK_PAYOUT_TYPE = 'BULK';

export const BANK_SECRETS_MODE = {
  CONNECT: 'connect',
  SETTINGS: 'settings',
};

export const VALIDATION_ERROR_TYPES = {
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  INVALID_DATA: 'INVALID_DATA',
};

export const MAX_FILE_SIZE_LIMITS = 5 * 1024 * 1024;
